import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CTASection = () => {
  return (
    <section className="py-20 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Ready to simplify workforce management?
        </h2>
        <p className="text-primary-foreground/80 max-w-2xl mx-auto mb-8">
          Join teams who have moved beyond spreadsheets and complicated systems.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" variant="secondary" asChild>
            <Link to="/auth?tab=signup">Get started</Link>
          </Button>
          <Button size="lg" variant="outline" className="bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary" asChild>
            <Link to="/auth?tab=signin">Sign in</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
